module.exports = __webpack_public_path__ + "static/media/all_products.c5bbdfac.png";